import React from "react";
import "./DetailsOfShareholding.scss";
import detailsOfShareholder1 from "../../../assets/About/detailsOfShareholder1.png";
import detailsOfShareholder2 from "../../../assets/About/detailsOfShareholder2.png";

const DetailsOfShareholding = () => {
  return (
    <>
      <div className="details_shareholding">
        <div className="container-fluid p-0">
          <div className="container">
            <div className="heading_box">Details Of Shareholding</div>

            <div className="d-flex flex-column align-items-center">
              <div
                className="nav flex-column nav-pills"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <button
                  className="nav-link active"
                  id="v-pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-home"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-home"
                  aria-selected="true"
                >
                  Details of shareholding (segregate with Sponsors/Directors,
                  Institutions and General shareholders and percentage of
                  holding) as on 31st December, 2024.
                </button>
                <button
                  className="nav-link"
                  id="v-pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-profile"
                  aria-selected="false"
                >
                  Details of shareholding position of sponsors/Directors as on
                  31st December, 2024
                </button>
              </div>

              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                >
                  <img
                    src={detailsOfShareholder1}
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-profile-tab"
                >
                  <img
                    src={detailsOfShareholder2}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailsOfShareholding;
